module.exports = "/static/Images/es/Eight.png";